/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

export type LabTestCollectionMethodT =
  (typeof LabTestCollectionMethodT)[keyof typeof LabTestCollectionMethodT];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabTestCollectionMethodT = {
  testkit: "testkit",
  walk_in_test: "walk_in_test",
  at_home_phlebotomy: "at_home_phlebotomy",
  on_site_collection: "on_site_collection",
} as const;
